module.exports = __webpack_public_path__ + "files/2191a3758ce0193eedf28b1ed990ff18.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/travel_places-2.png
// module id = 513
// module chunks = 76